import { useContext } from 'react';

import { PrivateEchoPresenceWebsocketService } from '../../services';
import { WebsocketContext } from '../../WebsocketContext';

export const usePrivatePresenceWebsocketService =
  (): PrivateEchoPresenceWebsocketService => {
    const { privatePresenceWebsocketService } = useContext(WebsocketContext);

    if (!privatePresenceWebsocketService) {
      throw new Error(
        'Private Presence Websocket Service has not been initialized',
      );
    }

    return privatePresenceWebsocketService;
  };
